<template>
  <b-modal
    v-model="showModal"
    @hide="$emit('on-hide')"
    centered
    body-class="pd-0"
    size="lg"
    scrollable
  >
    <template #modal-header class="pd-y-20 pd-x-20 pd-sm-x-30">
      <a
        @click="$emit('on-hide')"
        role="button"
        class="close pos-absolute t-20 r-20"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </a>
      <div class="media align-items-center">
        <span class="tx-color-03 d-none d-sm-block">
          <feather type="message-circle" class="wd-40-f ht-40-f"></feather>
        </span>
        <div class="media-body mg-sm-l-20">
          <h4 class="tx-18 tx-sm-20 mg-b-2">
            Мессенжерт хавсралт болгож илгээх
          </h4>
          <p class="tx-13 tx-color-03 mg-b-0">
            Бүлэг эсвэл хүнээ сонгоод илгээх дарна уу
          </p>
        </div>
      </div>
    </template>
    <div class="modal-body pd-0">
      <div class="card card-widget card-contacts bd-0">
        <div class="card-body pd-0 bd-0">
          <template v-if="team_filtered.length > 0">
            <ul class="list-group list-group-flush">
              <li
                role="button"
                class="list-group-item"
                v-for="(team, i) in team_filtered"
                :key="`tmcstm_${i}`"
                @click="selectedTeam = team"
                v-bind:style="{
                  backgroundColor:
                    selectedTeam.id == team.id ? 'rgb(213, 232, 252)' : '',
                }"
              >
                <div class="list-body">
                  <h6>{{ team.team }}</h6>
                  <p v-if="team.lastMessage != null">
                    {{ team.lastMessage.msg }}
                  </p>
                  <p v-else></p>
                </div>
              </li>
            </ul>
          </template>
          <template v-else>
            <div class="pd-10">
              <div class="alert alert-light" role="alert">
                <h4 class="alert-heading">Хоосон!</h4>
                <p>Сонгосон бүлгийн төрөл эсвэл хайлт илэрцгүй байна.</p>
                <hr />
                <p class="mb-0">Тохирох бүлгийн төрлөө сонгоно уу.</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="d-flex wd-100p">
        <div
          class="
            d-flex
            align-items-center
            dropdown
            dropup
            dropdown-notification
          "
        >
          <a
            id="dropupMenuButton"
            class="pd-r-5 dropdown-toggle dropdown-link new-indicator"
            data-toggle="dropdown"
            role="button"
          >
            <feather type="menu"></feather> Бүлгийн төрөл сонгох
            <span>{{flags.length}}</span>
          </a>
          <div class="dropdown-menu tx-13" aria-labelledby="dropupMenuButton">
            <ul class="nav nav-pills flex-column">
              <li v-for="(f, i) in flags" :key="`fl_${i}`" class="nav-item">
                <a @click="setFlag(f)" class="nav-link" role="button"
                  >{{ f.name }}
                  <span class="badge badge-info">{{ f.count }}</span></a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="d-flex align-items-center wd-50p">
          <div class="search-form d-none d-sm-flex pd-l-10">
            <input
              v-model="filterParam.fullname"
              type="search"
              class="form-control"
              placeholder="Хайх"
            />
            <button class="btn" type="button">
              <feather
                type="search"
                style="width: 16px; height: 16px"
              ></feather>
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-end wd-50p">
          <button
            @click="$emit('on-hide')"
            type="button"
            class="btn btn-white"
            data-dismiss="modal"
          >
            {{ isSend ? "Хаах" : "Болих" }}
          </button>
          <button
            v-show="!isSend"
            @click="shareToMessenger()"
            type="button"
            class="btn btn-primary mg-l-5"
          >
            <feather type="send"></feather>
            Илгээх
          </button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: () => false,
    },
    prms: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rdy: false,
      config: {},
      summerKey: 0,
      isSend: false,
      processing: false,
      teams: [],
      selectedTeam: { id: 0 },
      filterParam: {
        fullname: "",
        flag: 0,
      },
      flags: [],
    };
  },
  methods: {
    ...mapActions(["handleMessenger"]),
    setFlag(flag) {
      this.filterParam.flag = flag.id;
      //this.loadTeams();
      this.init();
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      request({
        api: { method: "get", url: "team/GetTeamConversations" },
        params: {
          page: 0,
          size: 1000,
          flag: this.filterParam.flag,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.rdy = true;
          this.teams = res.data.conversations;
          this.flags = res.data.flags;
        }
      });
    },
    shareToMessenger() {
      if (this.selectedTeam.id != 0) {
        this.$store.state.signalr.osrCon
          .invoke(
            "v2sendTeamMessage",
            this.$store.state.user.userInfo.profileId,
            this.selectedTeam.id,
            "хавсралт",
            this.prms.objectTypeId == 6 ? 1 : 2,
            this.prms.objectId,
            null,
            null
          )
          .catch(() => {
            this.$bvToast.toast("Дахин ачааллана уу", {
              title: "Сүлжээний холболт салсан байна",
              autoHideDelay: 10000,
              appendToast: true,
              variant: "warning",
              toaster: "b-toaster-bottom-left",
            });
          })
          .then(() => {
            let obj = this.$store.state.app.messenger;
            obj.open = true;
            //console.log("this.selectedTeam.flag", this.selectedTeam);
            obj.activeFlag = this.selectedTeam.flag;
            obj.openId = this.selectedTeam.id;
            this.handleMessenger(obj).then(() => {
              this.showMessenger = false;
            });
            this.$emit("on-hide");
          });
      } else {
        this.$bvToast.toast("Илгээх хүн эсвэл бүлгээ сонгоно уу", {
          title: "Мэдэгдэл",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "warning",
          toaster: "b-toaster-bottom-left",
        });
      }
    },
  },
  computed: {
    team_filtered() {
      let self = this;
      let _un = self.filterParam.fullname.toLowerCase();

      return this.teams.filter((c) => {
        return c.team != null && c.team.toLowerCase().indexOf(_un) > -1;
      });
    },
    showModal: {
      get: function () {
        if (this.isShow) this.init();
        return this.isShow;
      },
      set: function () {},
    },
  },
};
</script>
